import { useState, useEffect } from 'react';

const PHONE = '03-3261-9551';
const LOGO = 'https://static.readdy.ai/image/3b449c48e525fa5b7f514f383582948f/a6aa99d086618289a416ba1d8c9e0dad.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'サービスの強み', id: 'strengths' },
    { label: '対応業務', id: 'services' },
    { label: '対応エリア', id: 'area' },
    { label: '会社概要', id: 'company' },
    { label: 'お問い合わせ', id: 'contact' },
    { label: '採用情報', id: 'recruitment' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <button
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img src={LOGO} alt="株式会社S.A.Securityロゴ" className="h-9 w-auto object-contain" />
          <span className={`text-sm font-bold whitespace-nowrap tracking-wide transition-colors ${scrolled ? 'text-[#0D1A4E]' : 'text-white'}`}>
            株式会社S.A.Security
          </span>
        </button>

        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-[#0D1A4E] hover:text-[#38BDF8]' : 'text-white/90 hover:text-[#38BDF8]'
              }`}
            >
              {link.label}
            </button>
          ))}
          <a
            href={`tel:${PHONE}`}
            className="bg-[#38BDF8] hover:bg-[#7dd3fc] text-[#0D1A4E] px-5 py-2 rounded-md font-bold whitespace-nowrap transition-colors flex items-center gap-2 cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm"></i>
            </div>
            {PHONE}
          </a>
        </div>

        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className={`w-5 h-5 flex items-center justify-center ${scrolled ? 'text-[#0D1A4E]' : 'text-white'}`}>
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </div>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-b border-gray-200">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.id)}
                className="text-left text-sm font-medium text-[#0D1A4E] hover:text-[#38BDF8] transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <a
              href={`tel:${PHONE}`}
              className="bg-[#38BDF8] text-[#0D1A4E] px-5 py-2.5 rounded-md font-bold whitespace-nowrap text-center cursor-pointer text-sm"
            >
              <i className="ri-phone-fill mr-2"></i>{PHONE}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export { PHONE };
